import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  Signal,
  ViewEncapsulation,
} from '@angular/core';

import { Participant, ParticipantKind } from '@clientwire/api';
import { ParticipantListItemComponent } from '../../molecules/participant-list-item/participant-list-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { ParticipantWithSourceId } from '../../../stores/active-conversation.store';
import { UserState } from '../../../stores/user.store';

@Component({
  selector: 'shared-participant-list',
  standalone: true,
  imports: [ParticipantListItemComponent, TranslateModule],
  templateUrl: './participant-list.component.html',
  styleUrl: './participant-list.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantListComponent {
  readonly participants = input<Participant[]>();
  readonly user = input<UserState>();
  readonly menuClicked = output<{ type: string; participant?: Signal<ParticipantWithSourceId> }>();
  readonly participantsWithoutWorkflow = computed(() =>
    this.participants()?.filter((participant) => participant.kind !== ParticipantKind.Workflow)
  );
}
